import { render, staticRenderFns } from "./addEntrust.vue?vue&type=template&id=12d792b8&scoped=true&"
import script from "./addEntrust.vue?vue&type=script&lang=js&"
export * from "./addEntrust.vue?vue&type=script&lang=js&"
import style0 from "./addEntrust.vue?vue&type=style&index=0&id=12d792b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d792b8",
  null
  
)

export default component.exports